// The conjoint question icon, drawn by both conjoint heads. Ported from the svg_icons/qs/cjc ERB
// partial - the only place the icon is needed in React, so the paths live inline. Fills are set
// directly (they were global .chart-data-head-icon.cjc rules before the module refactor).
const HeadIcon = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="52.7px"
    height="57.64px"
    viewBox="0 0 52.7 57.64"
    xmlSpace="preserve"
  >
    <g transform="translate(-10.833861,-7.3636396)">
      <path
        fill="#b8e6da"
        d="m 61.12,28.63 c -0.01508,-4.272065 -2.300244,-8.213981 -6,-10.35 l -12,-6.92 c -3.712813,-2.1435935 -8.287187,-2.1435935 -12,0 l -12,6.92 c -3.699756,2.136019 -5.984924,6.077935 -6,10.35 v 13.84 c 0.01508,4.272065 2.300244,8.213981 6,10.35 l 12,6.92 c 3.712813,2.143594 8.287187,2.143594 12,0 l 12,-6.92 c 3.699756,-2.136019 5.984924,-6.077935 6,-10.35 z m 2.41,0 v 13.84 c -0.0084,5.12649 -2.743409,9.861415 -7.18,12.43 l -12,6.92 c -4.442105,2.555158 -9.907895,2.555158 -14.35,0 L 18,54.9 C 13.563409,52.331415 10.828352,47.59649 10.82,42.47 V 28.63 C 10.828352,23.50351 13.563409,18.768585 18,16.2 L 30,9.28 c 4.442651,-2.5531117 9.907349,-2.5531117 14.35,0 l 12,6.92 c 4.436591,2.568585 7.171648,7.30351 7.18,12.43 z"
      />
      <path fill="#e49400" d="m 26.9,20.62 -8.28,5.22 -0.1,-0.07 V 45.2 l 6.87,4.38 V 30.2 l 7.73,-5.31 z" />
      <path fill="#c8161a" d="m 43.19,17.9 -6,-3.8 -6.19,3.9 6,4.19 z" />
      <path
        fill="#a0c646"
        d="m 44.71,32.77 -0.09,0.05 -7.62,-5.24 -7.56,5.23 0.17,0.11 v 19.31 l 7.58,4.77 7.52,-4.81 v -19.31 0 0 z"
      />
      <path fill="#6cace2" d="M 47.35,20.53 41,24.89 48.81,30.3 v 19.41 l 7,-4.51 V 25.81 l -0.1,0.07 z" />
    </g>
  </svg>
)

HeadIcon.displayName = 'ConjointHeadIcon'

export default HeadIcon
